import coupon from "./coupon";
import seckill from "./seckill";
import manjian from "./manjian";
import mansong from "./mansong";
import dealer from "./dealer";
import points from "./points";
import diy from "./diy";

export default [
    {
        path: '/app/index.html',
        component: (resolve) => require(['@/view/app/index.vue'],resolve),
    },
    ...coupon,
    ...seckill,
    ...manjian,
    ...mansong,
    ...dealer,
    ...points,
    ...diy
]
